import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";

type Props = {
  columns: columnTypes[];
  rows: any[];
  cashAmount:any;
  upiAmount:any;
  netBankingAmount:any;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
  onFilterClick: () => void;
};

const TransactionsListing = ({
  columns,
  rows,
  cashAmount ,upiAmount ,netBankingAmount ,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
  onFilterClick,
}: Props) => { 
  return (
      <div className="flex flex-col p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            pageTitle="Transactions"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton={true}
            isFilter={true}
            onFilterClick={onFilterClick}
          />
        </div>
        {/* ₹ */}
        <div className="mb-3 grid xl:grid-cols-5  sm:grid-cols-3  gap-6">
          <div className="flex flex-col shadow-md bg-gray-50 justify-center items-center xl:col-start-2  hover:bg-hover py-1">
            <span className="font-semibold text-lg text-primary-main">UPI Amount </span>
            <span className="text-[18px] font-medium">₹{upiAmount || 0}</span>
          </div>
          <div className="flex flex-col shadow-md bg-gray-50 justify-center items-center hover:bg-hover py-1">
            <span className="font-semibold text-lg text-primary-main">Cash Amount </span>
            <span className="text-[18px] font-medium">₹{cashAmount || 0}</span>
          </div>
          <div className="flex flex-col shadow-md bg-gray-50 justify-center items-center hover:bg-hover py-1">
            <span className="font-semibold text-lg text-primary-main">Net Banking Amount </span>
            <span className="text-[18px] font-medium">₹{netBankingAmount || 0}</span>
          </div>
        </div>
        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-4 py-2 flex justify-end">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
    
  );
};

export default TransactionsListing;
